/* eslint-disable max-len */
import React from 'react';
function Recruitment() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M15,12c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S12.8,12,15,12z M6,10V7H4v3H1v2h3v3h2v-3h3v-2H6z M15,14c-2.7,0-8,1.3-8,4v2 h16v-2C23,15.3,17.7,14,15,14z" })));
}
export default Recruitment;
